import type {
    Translatable} from "@@/shared/translations/translation";
import {
    translatableZodSchema,
} from "@@/shared/translations/translation";
import type { Except } from "type-fest";
import { z } from "zod";
import type { ProviderId} from "../provider-id";
import { providerIdZodSchema } from "../provider-id";

type ProviderPauseCommand = {
    _type: "PROVIDER_PAUSE_COMMAND";
    providerId: ProviderId;
    durationInMinutes: number;
    reason?: Translatable;
    reasonTitle?: Translatable;
};

const providerPauseCommandZodSchema: z.ZodSchema<ProviderPauseCommand> =
    z.object({
        _type: z.literal("PROVIDER_PAUSE_COMMAND"),
        providerId: providerIdZodSchema,
        durationInMinutes: z.number().min(0),
        reason: translatableZodSchema.optional(),
        reasonTitle: translatableZodSchema.optional(),
    });
const providerPauseCommandFactory = (
    params: Except<ProviderPauseCommand, "_type">,
): ProviderPauseCommand => {
    return {
        ...params,
        _type: "PROVIDER_PAUSE_COMMAND",
    };
};
export { providerPauseCommandFactory, providerPauseCommandZodSchema };
export type { ProviderPauseCommand };
